import { SearchWorkflowTemplatesRequest } from "../../../../../service/query";
import { FilterGroups } from "../../../../../service/Shared";

export const getWorkflowTemplateExpiryFilterGroups = (
  showExpired: boolean
): FilterGroups<SearchWorkflowTemplatesRequest["filter"]> => {
  if (showExpired) {
    return {};
  }

  return {
    filterGroups: [
      {
        operator: "or",
        filterGroups: [
          {
            operator: "and",
            filter: {
              results: {
                validTo: {
                  operator: "gte",
                  value: new Date(),
                },
              },
            },
          },
          {
            operator: "and",
            filter: {
              results: {
                validTo: {
                  operator: "eq",
                  value: null,
                },
              },
            },
          },
        ],
      },
    ],
  };
};
